// src/layouts/scenarios/create/data/useScenarioAreasData.js

import { useEffect, useState } from "react";
import { fetchArea } from "../functions/fetchArea";

function useScenarioAreasData(selectedKpi, preloadedAreas = []) {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const monitoringType = selectedKpi?.monitoring?.type;

  useEffect(() => {
    if (monitoringType !== "areas") {
      setAreas([]);
      setLoading(false);
      setError(null);
      return;
    }

    if (preloadedAreas.length) {
      setAreas(preloadedAreas);
      setLoading(false);
      setError(null);
      return;
    }

    let isCancelled = false;

    const loadAreas = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchArea();
        if (!isCancelled) {
          // pass-through from fetchArea (already normalized)
          setAreas(data);
        }
      } catch (err) {
        if (!isCancelled) {
          console.error("Error in useScenarioAreasData:", err);
          setError(err);
          setAreas([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };
    loadAreas();

    return () => {
      isCancelled = true;
    };
  }, [monitoringType, preloadedAreas]);

  return { areas, loading, error };
}

export default useScenarioAreasData;
